import React from 'react';
import { FloatingPortal, Placement, useFloating, useHover, useInteractions } from "@floating-ui/react";

interface IToolbubbleProps extends React.PropsWithChildren  {
    className?: string;
    title: string;
    content: string | React.JSX.Element;
    placement?: Placement;
    delay?: {
        open: number,
        close: number
    }
}

const Toolbubble = (props: IToolbubbleProps) => {
    const { children, content, className, delay, placement, title } = props;

    const [isOpen, setIsOpen] = React.useState(false);

    const { refs, floatingStyles, context } = useFloating({
        open: isOpen,
        placement: placement ?? 'top',
        onOpenChange: setIsOpen
    });

    const hover = useHover(context, { delay: {
        open: delay?.open ?? 500,
        close: delay?.close ?? 125,
    } });

    const { getReferenceProps, getFloatingProps } = useInteractions([hover]);

    return (
        <>
            {isOpen && (
                <FloatingPortal>
                    <div
                        className="floating p-8 text-sm border outline-2 border-border-default rounded-2xl bg-white text-text-dark"
                        ref={refs.setFloating}
                        style={{
                            ...floatingStyles,
                            maxWidth: '350px'
                        }}
                        {...getFloatingProps()}
                    >
                        <span className="mb-4 text-xl font-medium">{title}</span>
                        <p className="text-xs text-justify">{content}</p>
                    </div>
                </FloatingPortal>
            )}
            <div
                className={`size- flex justify-end items-end ${className}`}
                ref={refs.setReference}
                {...getReferenceProps()}
            >
                {children}
            </div>
        </>
    );
};

export default Toolbubble;
